import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendOnboarding } from '../../../../features/session/sessionSlice'

function DashboardQuestion(){
    const dispatch = useDispatch()

    const onboardingState = useSelector(state => state.session.onboarding)
    const questions = onboardingState.qAndA
    return <div>
        <div class="form-group">
            <strong for="crm">{questions.q1.question}</strong>
            <input type="text" class="form-control" id="crm" value={questions.q1.answer} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q1: {
                        ...questions.q1,
                        answer: e.target.value
                    }
                }
            }))} />
            <small class="form-text text-red">* Required</small>
        </div>
        <div class="form-group">
            <strong for="platform">{questions.q2.question}</strong>
            <textarea class="form-control" id="platform" value={questions.q2.answer} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q2: {
                        ...questions.q2,
                        answer: e.target.value
                    }
                }
            }))} />
            <small class="form-text text-red">* Required</small>
        </div>
        <div class="form-group">
            <strong>{questions.q3.question}</strong>
            <br />
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="frandevStats" id="franDevYes" value="Yes" checked={questions.q3.answer === "Yes"} onChange={(e) => dispatch(appendOnboarding({
                    qAndA: {
                        ...questions,
                        q3: {
                            ...questions.q3,
                            answer: e.target.value
                        }
                    }
                }))} />
                <strong class="form-check-label" for="franDevYes">Yes</strong>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="frandevStats" id="franDevNo" value="No" checked={questions.q3.answer === "No"} onChange={(e) => dispatch(appendOnboarding({
                    qAndA: {
                        ...questions,
                        q3: {
                            ...questions.q3,
                            answer: e.target.value
                        }
                    }
                }))} />
                <strong class="form-check-label" for="franDevNo">No</strong>
            </div>

            <small class="form-text text-red">* Required</small>
        </div>
        <div class="form-group">
            <strong>{questions.q4.question}</strong>
            <br />
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="keywords" id="keywordYes" value="Yes" checked={questions.q4.answer === "Yes"} onChange={(e) => dispatch(appendOnboarding({
                    qAndA: {
                        ...questions,
                        q4: {
                            ...questions.q4,
                            answer: e.target.value
                        }
                    }
            }))} />
                <strong class="form-check-label" for="keywordYes">Yes</strong>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="keywords" id="keywordNo" value="No" checked={questions.q4.answer === "No"} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q4: {
                        ...questions.q4,
                        answer: e.target.value
                    }
                }
            }))} />
                <strong class="form-check-label" for="keywordNo">No</strong>
            </div>
            <small class="form-text text-red">* Required</small>
        </div>
        <div class="form-group">
            <strong>{questions.q5.question}</strong>
            <br />
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="vetfran" id="vetfranYes" value="Yes" checked={questions.q5.answer === "Yes"} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q5: {
                        ...questions.q5,
                        answer: e.target.value
                    }
                }
            }))} />
                <strong class="form-check-label" for="vetfranYes">Yes</strong>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="vetfran" id="vetfranNo" value="No" checked={questions.q5.answer === "No"} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q5: {
                        ...questions.q5,
                        answer: e.target.value
                    }
                }
            }))} />
                <strong class="form-check-label" for="vetfranNo">No</strong>
            </div>
            <small class="form-text text-red">* Required</small>
        </div>
        <div class="form-group">
            <strong>{questions.q6.question}</strong>
            <br />
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="addBrand" id="addBrandYes" value="Yes" checked={questions.q6.answer === "Yes"} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q6: {
                        ...questions.q6,
                        answer: e.target.value
                    }
                }
            }))} />
                <strong class="form-check-label" for="addBrandYes">Yes</strong>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="addBrand" id="addBrandNo" value="No" checked={questions.q6.answer === "No"} onChange={(e) => dispatch(appendOnboarding({
                qAndA: {
                    ...questions,
                    q6: {
                        ...questions.q6,
                        answer: e.target.value
                    }
                }
            }))} />
                <strong class="form-check-label" for="addBrandNo">No</strong>
            </div>
            <small class="form-text text-red">* Required</small>
        </div>
    </div>
}

export default DashboardQuestion